module.exports = __webpack_public_path__ + "img/64be33f89cd1b00382deea2a73b44722.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/images/operational_journal.jpg
 ** module id = 421
 ** module chunks = 0
 **/